var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['newdrawLots', { inApp: _vm.$root.$data.isApp }]},[_c('common-title',{attrs:{"titleName":"压力测试","bcColor":'#fff',"zIndex":1000}}),_c('section',{staticClass:"section"},[_c('div',{staticClass:"drawWarrp"},[_c('p',{staticClass:"chou",on:{"click":_vm.drawBtn}},[_vm._v("开始测试")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }